export default "__VITE_ASSET__dczNad1K__"